<div class="excel-download" [ngClass]="{ 'excel-ar-download': current_lang === 'ar' }">
 
    <!--- Download option -->
    <div class="download-excel-outer" *ngIf="
      tableData?.length !== 0 &&
      tableData &&
      allowExcelDownload
    ">
        <button class="download_excel" [disabled]="LockReport" *ngIf="!downloadLoading" (click)="downloadExcel()"
            matTooltip="{{ 'reports.download_excel' | translate }}" matTooltipPosition="above"><img *ngIf="!LockReport"
                src="../../../../../../assets/images/excel-icon.svg" />
            <img *ngIf="LockReport" src="../../../../../../assets/images/excel-icon-disable.svg" /></button>
        <span *ngIf="downloadLoading"><mat-spinner class="download-spinner"></mat-spinner></span>
    </div>
    <!--- Download option -->
</div>

<div class="main-table">
    <table class="table" matSort (matSortChange)="onSortTable($event)">
        <thead>
            <tr>
                <ng-container *ngFor="let tableColumn of tableColumns">

                    <!-- Conditionally render <th> with or without mat-sort-header -->
                    <th *ngIf="tableColumn.isSortable;" mat-sort-header="{{ tableColumn.header }}"
                        [class.custom-bg-th]="tableColumn.border">
                            <span class="header_label">
                                {{ tableColumn?.columnName | translate }}
                                <span class="text-transform-normal">{{ tableColumn?.symbol | reportDataValueType }}</span>
                            </span>
                    </th>

                </ng-container>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let element of tableData; let i = index"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                (click)="setExpadndColor(i)" [@detailExpand]="element.isOpen === 1 ? 'collapsed' : 'expanded'"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                [ngClass]="(expandedElement === element && !element['outlier'] ? 'example-expanded-row':'')"
                [ngClass]="{ hideTable: !showLoader }"
                [ngClass]="{'tr-parent': element.isParent, 'tr-child': !element.isParent}"
                [class.expand-hide]="element.isOpen === 1" [ngClass]="{'blur-content': element['NODATA']}">

                <td>
                    <div class="column-data align-items-center position-relative">
                        <div class="tooltip showonmap-column">
                            <!-- Column Name Text -->
                              <span class="column_entry tenantname_unit" [attr.title]="element?.tenant_name_unit_number"
                                [ngClass]="{'active_child_layout' : selectedIndex === ('' + goToPageNumber + i) && tableColumns[0]?.isTenent && colType == 'layout'}"
                                [ngClass]="{'link_item': selectedIndex === ('' + goToPageNumber + i) && tableColumns[0]?.isTenent && colType == 'layout'}">
                                {{element?.tenant_name_unit_number }}
                            </span>
                          
                        </div>
                        <span class="tenent_map_icon icon__ show_on_map" matTooltip="{{'reports.show_floor_plan' | translate}}"
                         [ngClass]="{'clicked_item_layout': !tenantLoading && colType == 'layout' && selectedIndex === ('' + goToPageNumber + i)}" 
                         *ngIf="(element?.lat) && element?.is_layout" (click)="panToMap(element, tableColumns[0].field, i, 'layout', false, false, tableColumns[0]?.unitLayout)"><mat-icon svgIcon="layoutIcon" class="icon"></mat-icon></span>
                      
                    </div>
                </td>
                <td>
                    <div class="column-data align-items-center position-relative">
                        <div class="tooltip showonmap-column">
                            <!-- Column Name Text -->
                              <span class="column_entry" [attr.title]="element?.property_name"
                                (click)="panToMap(element, tableColumns[1].field, i, 'showOnMap', true, element?.is_layout)"
                                [ngClass]="{'link_item': (element?.lat && tableColumns[1]?.showOnMap && tableColumns[1]?.isAnchor && element.isParent)}">
                                {{element?.property_name }}
                            </span>
                          
                        </div>
                         <span *ngIf="element.isParent" class="show_on_map"
                                [ngClass]="{'clicked_item': colType == 'showOnMap' && selectedIndex === ('' + goToPageNumber + i)}"
                                (click)="panToMap(element, tableColumns[1].field, i, 'showOnMap')"
                                matTooltip="{{'reports.show_on_map' | translate}}">
                                <mat-icon svgIcon="location" class="icon" *ngIf="!element?.is_layout"></mat-icon>
                                <mat-icon svgIcon="floorLayoutIcon" class="icon" *ngIf="element?.is_layout"></mat-icon>
                            </span>
                            <!-- Show On Map Loader -->
                            <span class="tenent_map_icon loader__"
                                *ngIf="(element?.lat || element?.tenants_lat_lon) && selectedIndex === ('' + goToPageNumber + i) && tenantLoading"
                                [ngClass]="{'clicked_item': tenantLoading && selectedIndex === ('' + goToPageNumber + i)}"><mat-spinner
                                    class="download-spinner"></mat-spinner></span>
                    </div>
                </td>  
               
                <td>{{element?.floor ?? '-'}}</td>
                <td>{{(element?.gross_area | number: '1.0-1') ?? '-'}}</td>
                <td>{{(element?.lease_rate | number: '1.0-1') ?? '-'}}</td>
                <td>{{(element?.rental_price | number: '1.0-1') ?? '-'}}</td>
                <td>{{element?.is_anchor ?? '-'}}</td>
                <td>{{element?.neighborhood ?? '-'}}</td>
                <td>{{element?.tenant_category ?? '-'}}</td>
                <td>{{element?.property_uid ?? '-'}}</td>
                <td>{{element?.unit_uid ?? '-'}}</td>
                <td>{{element?.categories ?? '-'}}</td>
               
            </tr>
            <tr *ngIf="!showLoader" style="height: auto;" class="loader-tr">
                <td style="padding: 0;" [attr.colspan]="tableColumns?.length">
                    <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    <!--- No Record Found -->
    <div class="data_unavail" *ngIf="(tableData?.length === 0 || !tableData) && showLoader">
        <span>
            {{"reports.dataComingSoon" | translate}}
        </span>
    </div>
    <!-- Table content blur start -->
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>
<!--- Pagination -->
<div class="pagination-wrapper pagination-showing-count"
    *ngIf="tableData?.length !== 0 && tableData && !hidePagination">
    <ng-container *ngIf="show_step_count">
        <p *ngIf="!LockReport" [class.showingrecord-margin]="dataLength > 2">
            {{ "reports.Showing" | translate }} {{ startIndex }}
            {{ "reports.to" | translate }} {{ endIndex }}
            {{ "reports.outOf" | translate }}
            {{ dataLength | internationalNumber }}
            {{ "reports.records" | translate}}
        </p>
    </ng-container>
    <p *ngIf="LockReport" class="pb-2">
        <span class="contact-sale" (click)="openContactSales()">{{'contactSales' | translate }}</span>
        {{'to_unlock' | translate }} <ng-container *ngIf="dataLength > 3"> {{(dataLength
            - 3) | internationalNumber }} {{'rows_more'| translate}}</ng-container> <ng-container
            *ngIf="dataLength <= 3">{{'more_rows'|
            translate}}</ng-container>.
    </p>

    <mat-paginator *ngIf="dataLength > 20" [disabled]="!showLoader || LockReport" class="default-pagination"
        [length]="dataLength" [pageSize]="20" [pageSizeOptions]="[5, 10, 15, 25, 100]" [showFirstLastButtons]="true"
        (page)="onPageChange($event)" [hidePageSize]="true">
    </mat-paginator>

    <!-- Pagination input -->
    <div class="go-to-page d-flex align-items-center" *ngIf="dataLength > 20">
        <input class="go-to-page-input" type="number" [(ngModel)]="goToPageNumber" (change)="onGoToPage()"
            [disabled]="totalPages === 1 || !showLoader || LockReport" />
        <span class="oftext">of</span>
        <span>{{ totalPages }}</span>
    </div>
</div>

<!--- data cleaned Text -->
<div class="dataCleaned">
    <span>
        <ng-container *ngIf="showEstaterText">{{
            "reports.dataCleaned" | translate
            }}</ng-container>
    </span>

</div>